export default (state) => state.customerProducts.data || {}
